import { injectReducer } from "store/reducers";
import YearlyScheduler from "./routes/YearlyScheduler";
import WeeklyScheduler from "./routes/WeeklyScheduler";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { getRelativePath } from "Utils";
import ACLStore from "lib/aclStore";
import { goToRelativeRoute } from "modules/Services";

export default store => ({
  path: "scheduler",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-scheduler" */ "./components"),
        import(
          /* webpackChunkName: "course-scheduler" */ "./modules/SchedulerModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "scheduler",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (ACLStore.can("Common:ClassPlanners")) {
      const goToNewRoute = goToRelativeRoute({
        route: `${getRelativePath(
          nextState.pathname,
          "scheduler"
        )}/class-planners`,
      });
      store?.dispatch(goToNewRoute);
    }
  },
  childRoutes: [YearlyScheduler(store), WeeklyScheduler(store)],
});
